export default __webpack_public_path__ + "static/media/header-bg.151979d7.png";